<template>
  <basic-container>
    <page-search />
    <page-table />
    <sms-upload />
    <LogModel
      :title="'短信导入'"
      :visible="showLog"
      :active="'tripartiteResource'"
      @close="handleClose"
    />
  </basic-container>
</template>

<script >
import PageSearch from './components/page-search.vue';
import PageTable from './components/page-table.vue';
import SmsUpload from './components/sms-upload.vue';
import LogModel from '@/components/operateLog/oLog.vue';
import env from '@/config/env';
import dayjs from 'dayjs';
import { MessageBox, Loading, Message } from 'element-ui';
import { provide, ref, onMounted } from '@vue/composition-api';
import { useTableList, usePageRoute } from '@/hooks';
import { getTotalPage, getContent, getSum, getAppDic } from '@/api/source/index.js';
import { exportExcelPost } from '@/router/axios.js';

// 获取路由信息
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const {
    getRoute
  } = usePageRoute();
  const route = getRoute();
  const {
    appType = '',
    startDate = '',
    endDate = '',
    merchantId = ''
  } = route.params || {};
  const initParams = ref({});
  // 应用类型
  if (appType) {
    initParams.value.tripartiteResourceType = appType;
    initParams.value.tripartiteResourceTypeArr = appType.toString().split(',');
  }
  // 时间
  if (startDate) {
    initParams.value.startDate = startDate;
    initParams.value.endDate = endDate;
    initParams.value.dateArr = [startDate, endDate];
  } else {
    const eT = dayjs().format('YYYY-MM-DD');
    const sT = dayjs().subtract(29, 'day').format('YYYY-MM-DD');
    initParams.value.startDate = sT;
    initParams.value.endDate = eT;
    initParams.value.dateArr = [sT, eT];
  }
  // 供应商
  if (merchantId) {
    initParams.value.merchantId = merchantId;
  }
  const {
    loading,
    tableData,
    pageState,
    searchParam,
    handleCurrentChange,
    handleSizeChange,
    search,
    reset
  } = useTableList(getTotalPage, initParams.value);
  provide('loading', loading);
  provide('tableData', tableData);
  provide('pageState', pageState);
  provide('searchParam', searchParam);
  provide('handleCurrentChange', handleCurrentChange);
  provide('handleSizeChange', handleSizeChange);
  const handleSearch = () => {
    const {
      startDate = '',
      endDate = ''
    } = searchParam.value;
    const diffVal = dayjs(endDate).diff(dayjs(startDate), 'day');
    if (diffVal > 89) {
      Message.error('最多可以查询90天的数据');
      return;
    }
    search();
    queryAllMoney();
  };
  provide('search', handleSearch);
  const handleReset = () => {
    reset();
    queryAllMoney();
  };
  provide('reset', handleReset);

  // 导出
  const exportLoading = ref(false);
  provide('exportLoading', exportLoading);
  const handleExport = async () => {
    const params = searchParam.value;
    const {
      startDate = '',
      endDate = ''
    } = searchParam.value;
    if (!startDate || !endDate) {
      Message.error('请选择一个时间范围来导出数据');
      return;
    }
    const diffVal = dayjs(endDate).diff(dayjs(startDate), 'day');
    if (diffVal > 89) {
      Message.error('最多可以导出90天的数据');
      return;
    }
    exportLoading.value = true;
    try {
      const {
        code = 0
      } = (await exportExcelPost(`${env.ferryUrl}/tripartite-resource/export`, params)) || {};
      if (code !== 0) {
        return;
      }
      Message.success('文件正在下载中，请关注浏览器下载列表');
    } catch (error) {
      console.log(error);
    } finally {
      exportLoading.value = false;
    }
  };
  provide('handleExport', handleExport);

  // 查看内容
  const viewContent = async row => {
    const loadingInstance = Loading.service();
    const {
      code,
      data
    } = await getContent({
      id: row.id
    });
    loadingInstance.close();
    if (code !== 0) {
      return;
    }
    MessageBox.alert(data, '内容详情', {
      showConfirmButton: false
    });
  };
  provide('viewContent', viewContent);

  // 查总金额
  const allMoney = ref(0);
  provide('allMoney', allMoney);
  const queryAllMoney = async () => {
    const {
      code,
      data
    } = await getSum(searchParam.value);
    if (code !== 0) {
      return;
    }
    allMoney.value = data;
  };

  // 查字典数据
  const dicOptions = ref({});
  provide('dicOptions', dicOptions);
  const queryDic = async () => {
    const {
      code,
      data
    } = await getAppDic();
    if (code !== 0 || !Array.isArray(data)) {
      return;
    }
    const appTypeArr = data.map(item => {
      item.value = item.value + '';
      return item;
    });
    dicOptions.value = {
      appTypeArr
    };
  };

  // 营销短信导入
  const showUpload = ref(false);
  provide('showUpload', showUpload);
  const openUploadDialog = () => {
    showUpload.value = true;
  };
  provide('openUploadDialog', openUploadDialog);
  const closeUploadDialog = () => {
    showUpload.value = false;
  };
  provide('closeUploadDialog', closeUploadDialog);

  // 查看日志
  const showLog = ref(false);
  const viewLog = () => {
    showLog.value = true;
  };
  provide('viewLog', viewLog);
  const handleClose = () => {
    showLog.value = false;
  };
  onMounted(() => {
    queryAllMoney();
    queryDic();
  });
  return {
    showLog,
    handleClose
  };
};
__sfc_main.components = Object.assign({
  PageSearch,
  PageTable,
  SmsUpload,
  LogModel
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="scss" scoped></style>
